import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bf83d56a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=bf83d56a&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf83d56a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf83d56a')) {
      api.createRecord('bf83d56a', component.options)
    } else {
      api.reload('bf83d56a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=bf83d56a&scoped=true", function () {
      api.rerender('bf83d56a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/resultsAnalysis/index.vue"
export default component.exports